import { useState, useContext } from 'react';
import { AppContext } from '../../context/context'
import { baseUrl, apiUrl } from '../../config/delcare'
import UiButton1 from '../../components/ui_button1';
import UiSpinner from '../../components/ui_spinner';

const UiPopupSidebarUnsubscribe = () => {

    const {
        neonUser,
        offCanvas,
        toUnsubscribe,
        setReloadSubscription,
        token
    } = useContext(AppContext)

    const [unsubscribed, setUnsubscribed] = useState(false)
    const [load, setLoad] = useState(false)

    const unsubscribe = async () => {
        setLoad(true)

        let data = {
            customer_id: toUnsubscribe.id
        }

        let resp = await fetch(`${apiUrl}/stripe-cancel-subscription`, {
            method: "POST",
            headers: (() => {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append('Authorization', `Bearer ${token.accessToken}`)
                return myHeaders
            })(),
            body: JSON.stringify(data)
        })

        if (!resp.ok) {
            setLoad(false)
            return
        }

        setReloadSubscription(true)
        setUnsubscribed(true)
        setLoad(false)
        return
    }

    return (
        <div className="h-100">
            {unsubscribed ?
                <div className="h-100 d-flex flex-column justify-content-center">
                    <div className="d-flex flex-column gap-3">
                        <img className="align-self-center" src={baseUrl + "/src/unsub.png"} style={{ width: 40, height: 40 }} />
                        <p className="poppins text-center">
                            Your Subscription has been successfully cancelled. You will continue to have access until the end of your billing cycle.
                        </p>
                    </div>
                </div>
                :
                <div className="h-100 d-flex flex-column justify-content-between">
                    <p className="poppins">Are you sure you want to cancel this subscription?</p>
                    {load ?
                        <UiSpinner />
                        :
                        <UiButton1 text="Unsubscribe" submit={unsubscribe} />
                    }
                </div>
            }
        </div>
    )
}

export default UiPopupSidebarUnsubscribe